"use strict";

const getParam = (name, optSearch) => {
  "use strict";
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(optSearch);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

// HELPER FUNCTIONS
function gtm_getVariation(number_of_variations) {
  try {
    return "v" + Math.floor(Math.random() * number_of_variations);
  } catch (e) {
    console.error('Error in gtm_getVariation:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_getCookie(name) {
  try {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
  } catch (e) {
    console.error('Error in gtm_getCookie:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_setCookie(name, value, days) {
  try {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=.{{*Base URL}}";
  } catch (e) {
    console.error('Error in gtm_setCookie:', e.message);
    // Here, you might want to do something else if setting the cookie fails.
    // Returning "v0" may not make sense in this context, but you could still handle the error in some manner.
  }
}

var __proteusWaiters = [];
var __proteusWatchers = [];
var __proteusObserver = null;

function __proteusMaybeDisconnect() {
  if (__proteusObserver && !__proteusWaiters.length && !__proteusWatchers.length) {
    __proteusObserver.disconnect();
    __proteusObserver = null;
  }
}

function __proteusEnsureObserver() {
  if (__proteusObserver) return;
  __proteusObserver = new MutationObserver(function (mutations) {
    var resolvedAny = false;

    if (__proteusWaiters.length) {
      for (var m = 0; m < mutations.length; m++) {
        var mutation = mutations[m];
        var added = mutation.addedNodes;
        if (!added || !added.length) continue;

        if (mutation.target === document) continue;

        for (var i = 0; i < added.length; i++) {
          var node = added[i];
          for (var w = 0; w < __proteusWaiters.length; w++) {
            var waiter = __proteusWaiters[w];
            if (waiter.matched) continue;
            try {
              // Check the added node, then its subtree: apps often insert a wrapper whose child is the target
              var hit = node.matches && node.matches(waiter.selector)
                ? node
                : node.querySelector && node.querySelector(waiter.selector);
              if (hit) {
                waiter.matched = hit;
                resolvedAny = true;
              }
            } catch (e) {
            }
          }
        }
      }
    }

    if (resolvedAny) {
      var remaining = [];
      for (var k = 0; k < __proteusWaiters.length; k++) {
        var pending = __proteusWaiters[k];
        if (pending.matched) pending.resolve(pending.matched);
        else remaining.push(pending);
      }
      __proteusWaiters = remaining;
    }

    if (__proteusWatchers.length) {
      // Scan each added element and its subtree rather than its parent. Apps keep appending scripts and
      // iframes to <head>/<body>, and scanning the parent re-walked the whole document for every watcher
      // each time. matches() + querySelectorAll() on the added element find the same elements for
      // descendant/child selectors; a watcher that needs a sibling combinator (+, ~) would need the parent.
      var addedElements = [];
      var seen = typeof Set === 'function' ? new Set() : null;
      for (var m2 = 0; m2 < mutations.length; m2++) {
        var record = mutations[m2];
        if (!record.addedNodes || !record.addedNodes.length) continue;
        for (var n = 0; n < record.addedNodes.length; n++) {
          var addedNode = record.addedNodes[n];
          if (addedNode.nodeType !== 1 || !addedNode.parentElement) continue;
          if (seen) {
            if (seen.has(addedNode)) continue;
            seen.add(addedNode);
          } else if (addedElements.indexOf(addedNode) > -1) {
            continue;
          }
          addedElements.push(addedNode);
        }
      }

      if (addedElements.length) {
        var watchers = __proteusWatchers.slice();
        for (var o = 0; o < watchers.length; o++) {
          var watcher = watchers[o];
          if (!watcher.active) continue;
          for (var p = 0; p < addedElements.length; p++) {
            if (!watcher.active) break;
            try {
              if (watcher.look(addedElements[p])) break;
            } catch (e) {
            }
          }
        }
      }
    }

    __proteusMaybeDisconnect();
  });

  __proteusObserver.observe(document, {
    attributes: false,
    childList: true,
    subtree: true
  });
}

function waitForElement(selector) {
  return new Promise(function (resolve, reject) {
    var element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }
    __proteusWaiters.push({ selector: selector, resolve: resolve, matched: null });
    __proteusEnsureObserver();
  });
}

// Defers cart-only treatments until cart contents can actually be seen, so their
// observers are not scanning every mutation during page load. observeSelector()
// scans the existing DOM when it registers, so anything already rendered is still
// picked up. On the cart page the contents are visible immediately, so we run at once.
var __proteusCartQueue = [];
var __proteusCartReady = false;
var __proteusCartBound = false;

function __proteusFlushCart() {
  if (__proteusCartReady) return;
  __proteusCartReady = true;
  var queued = __proteusCartQueue;
  __proteusCartQueue = [];
  for (var i = 0; i < queued.length; i++) {
    try {
      queued[i]();
    } catch (e) {
      console.error('onCartContentVisible:', e && e.message);
    }
  }
}

function __proteusBindCartTriggers() {
  if (__proteusCartBound) return;
  __proteusCartBound = true;

  document.addEventListener('show.bs.offcanvas', function (e) {
    if (e.target && e.target.id === 'offcanvas-cart') __proteusFlushCart();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[href="#offcanvas-cart"], [data-bs-target="#offcanvas-cart"]')) {
      __proteusFlushCart();
    }
  }, true);

  var checkCartPage = function () {
    if (document.querySelector('#cart')) __proteusFlushCart();
  };
  checkCartPage();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkCartPage);
}

function onCartContentVisible(fn) {
  if (__proteusCartReady) {
    fn();
    return;
  }
  __proteusCartQueue.push(fn);
  __proteusBindCartTriggers();
}

// shim layer with setTimeout fallback
var requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 3000 / 60);
  };
}();
// Polls on a 50ms timer rather than on animation frames: a requestAnimationFrame loop makes the browser run a
// rendering frame ~60 times a second for as long as the condition stays false (WELL-23 polls for the whole
// visit on every product page outside its test), which added up to ~900ms of main-thread time on mobile.
function waitUntil(test) {
  return new Promise(function (resolve) {
    (function poll() {
      if (!test()) return setTimeout(poll, 50);
      return resolve();
    })();
  });
}
;
var observeSelector = function observeSelector(selector, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    timeout: null,
    once: false,
    onTimeout: null,
    document: window.document
  };
  var processed = new Map();
  if (options.timeout || options.onTimeout) {
    console.log('------------------------------------------------------------------------------------------------------------------------------');
    console.log('WARNING: observeSelector options timeout and onTimeout are not yet implemented.');
    console.log('------------------------------------------------------------------------------------------------------------------------------');
  }

  var ownDocument = options.document && options.document !== window.document
    ? options.document
    : null;

  var watcher = null,
    obs = null,
    isDone = false;
  var done = function done() {
    if (!watcher && !obs) console.warn('observeSelector failed to run done()');
    if (obs) obs.disconnect();
    if (watcher) {
      watcher.active = false;
      var idx = __proteusWatchers.indexOf(watcher);
      if (idx > -1) __proteusWatchers.splice(idx, 1);
    }
    processed = undefined;
    watcher = undefined;
    obs = undefined;
    __proteusMaybeDisconnect();
    return isDone = true;
  };
  var processElement = function processElement(el) {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };
  var lookForSelector = function lookForSelector() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      var elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
          var _el = elements[i];
          if (processElement(_el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone) {
    if (ownDocument) {
      obs = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (record) {
          if (record && record.addedNodes && record.addedNodes.length) {
            for (var i = 0; i < record.addedNodes.length; i++) {
              //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
              var el = record.addedNodes[i].parentElement;
              // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
              //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
              if (el && lookForSelector(el)) return true;
            }
          }
        });
      });
      obs.observe(ownDocument, {
        attributes: false,
        childList: true,
        subtree: true
      });
    } else {
      watcher = { active: true, look: lookForSelector };
      __proteusWatchers.push(watcher);
      __proteusEnsureObserver();
    }
  }
  return function () {
    done();
  };
}; //_observeSelector
